@if (!hideAll()) {
	<div *transloco="let t">
		<h1 class="title mt-0 mb-4">
			@if (flatratesExemptionsService.selectedType() === 'FLATRATE') {
				{{ t('billing.flatrates.title') }}
			} @else if (flatratesExemptionsService.selectedType() === 'EXEMPTION') {
				{{ t('billing.exemptions') }}
			}
		</h1>
		<div class="flex flex-col pl-2">
			<div class="flex flex-wrap justify-start items-start gap-2">
				<button (click)="back()" class="m-2" mat-fab type="button">
					<mat-icon>keyboard_return</mat-icon>
				</button>
				<mat-form-field appearance="outline" class="w-96 p-2">
					<mat-label>{{ t('billing.name') }}</mat-label>
					<input [ngModel]="costGroup().name" matInput disabled placeholder="{{ t('billing.name') }}" />
				</mat-form-field>
			</div>
			<table @stagger [dataSource]="dataSource" class="w-full" mat-table matSort>
				<ng-container matColumnDef="tenantUnit">
					<th *matHeaderCellDef mat-header-cell mat-sort-header>
						{{ t('billing.tenant') }}
					</th>
					<td *matCellDef="let row" mat-cell>
						@if (row.tenantUnit) {
							<div class="chip chip--primary overflow-clip text-ellipsis">{{ row.tenantUnit?.number }} / {{ row.tenantUnit?.subNumber }}</div>
						}
					</td>
				</ng-container>
				<ng-container matColumnDef="validFrom">
					<th *matHeaderCellDef mat-header-cell mat-sort-header>
						{{ t('common.from') }}
					</th>
					<td *matCellDef="let row" mat-cell>
						{{ dateUtil.setDateFormatByActiveLang(row.validFrom, '') }}
					</td>
				</ng-container>

				<ng-container matColumnDef="validTo">
					<th *matHeaderCellDef mat-header-cell mat-sort-header>
						{{ t('common.till') }}
					</th>
					<td *matCellDef="let row" mat-cell>
						{{ dateUtil.setDateFormatByActiveLang(row.validTo, '') }}
					</td>
				</ng-container>
				@if (flatratesExemptionsService.selectedType() === 'FLATRATE') {
					<ng-container matColumnDef="value">
						<th *matHeaderCellDef mat-header-cell mat-sort-header>
							{{ t('common.value') }}
						</th>
						<td *matCellDef="let row" mat-cell>{{ row.value }} €</td>
					</ng-container>
				}

				<ng-container matColumnDef="actions">
					<th *matHeaderCellDef mat-header-cell></th>
					<td *matCellDef="let row" mat-cell class="w-12 text-right">
						<button mat-icon-button [matMenuTriggerFor]="optionsMenu" (click)="$event.stopPropagation()">
							<mat-icon>more_vert</mat-icon>
						</button>
						<mat-menu #optionsMenu="matMenu">
							<button mat-menu-item (click)="edit(row)">
								<mat-icon color="primary">edit</mat-icon>
								<div>{{ t('commonActions.edit') }}</div>
							</button>
							<button mat-menu-item (click)="delete(row)">
								<mat-icon color="primary">delete</mat-icon>
								<div>{{ t('commonActions.delete') }}</div>
							</button>
						</mat-menu>
					</td>
				</ng-container>

				<tr *matHeaderRowDef="columns" mat-header-row></tr>
				<tr *matRowDef="let row; columns: columns" @fadeInUp (click)="edit(row)" class="hover:bg-hover trans-ease-out cursor-pointer" mat-row></tr>
				<!-- Row shown when there is no matching data. -->
				<tr *matNoDataRow class="mat-row">
					<td class="mat-cell" colspan="4">
						<div class="ml-4">
							{{ t('dashboard.noDataFound') }}
						</div>
					</td>
				</tr>
			</table>
			<div class="flex flex-row justify-center">
				<button (click)="new()" mat-raised-button>
					<mat-icon color="primary">add</mat-icon>
					<span>
						{{ t('billing.parameterValue.' + this.flatratesExemptionsService.selectedType()) }}
					</span>
				</button>
			</div>
			<mat-dialog-actions class="flex flex-row justify-end items-center pt-4" mat-dialog-actions>
				<button (click)="back()" mat-raised-button type="button">
					<mat-icon>keyboard_return</mat-icon>
					@if (!layoutService.isMobile()) {
						{{ t('commonActions.back') }}
					}
				</button>
			</mat-dialog-actions>
		</div>
	</div>
}
